import { FC } from 'react';
import { Link, useHistory } from 'react-router-dom';

import { Headline, Layout, Sidebar, SideNav } from '@servicetitan/design-system';

import { WebhookOperationModel } from '../models/webhook-operation-model';
import * as Styles from './docs.module.scss';

const WebhookOperationTable: FC<{
    webhooksPath: string;
    webhookOperations: WebhookOperationModel[];
}> = ({ webhooksPath, webhookOperations }) => (
    <table className={Styles.simple}>
        <tbody>
            {webhookOperations.map(operation => (
                <tr key={operation.operationId}>
                    <td className={Styles.operation}>
                        <Link
                            className={Styles.operationEndpoint}
                            to={`${webhooksPath}/${operation.name}`}
                        >
                            <span className={Styles.operationMethod} data-method={operation.method}>
                                {operation.method}
                            </span>
                            <span className={Styles.operationPath}>{operation.name}</span>
                        </Link>
                    </td>
                    <td>{operation.summary}</td>
                </tr>
            ))}
        </tbody>
    </table>
);

export const WebhookOperationList: FC<{
    webhooksPath: string;
    webhookOperations: WebhookOperationModel[];
}> = ({ webhooksPath, webhookOperations }) => (
    <Layout>
        <Layout.Section>
            <Headline>Webhooks</Headline>
            <WebhookOperationTable
                webhooksPath={webhooksPath}
                webhookOperations={webhookOperations}
            />
        </Layout.Section>
    </Layout>
);
WebhookOperationList.displayName = 'WebhookOperationList';

export const WebhookOperationListSidebar: FC<{
    webhooksPath: string;
    webhookOperations: WebhookOperationModel[];
    activeName: string;
}> = ({ webhooksPath, webhookOperations, activeName }) => {
    const history = useHistory();

    return (
        <Sidebar localStorageKey="sidebar:docs">
            <SideNav title={<Link to={webhooksPath}>Webhooks</Link>}>
                {webhookOperations.map(webhookOperation => (
                    <SideNav.Item
                        key={webhookOperation.operationId}
                        active={webhookOperation.name === activeName}
                        onClick={() => {
                            history.push(`${webhooksPath}/${webhookOperation.name}`);
                        }}
                    >
                        <div className={Styles.operationEndpoint}>
                            <span className={Styles.operationPath}>{webhookOperation.name}</span>
                        </div>
                    </SideNav.Item>
                ))}
            </SideNav>
        </Sidebar>
    );
};
WebhookOperationListSidebar.displayName = 'WebhookOperationListSidebar';
